export default __webpack_public_path__ + "static/media/placeholder-champions-cover.e0efa928.svg";